export default {
  breadcrumbs: '首頁/智慧物聯網儀表板',
  menu1: '智慧城市管理',
  menu2: '教材資源管理',
  menu3: '學習活動服務',
  menu4: '班級智慧服務',
}